var map = {
	"./KojisQuest_Poster.png": 723,
	"./Lenli_Poster.png": 559,
	"./Mobile-Menu.png": 693,
	"./NTBG_Poster.png": 973,
	"./Thomas.png": 8,
	"./VR_Poster.gif": 992,
	"./handshake-icon.png": 789,
	"./home-icon.png": 260,
	"./instagram-icon.webp": 575,
	"./mail-icon.png": 186,
	"./phone-icon.png": 221,
	"./soundcloud-icon.webp": 682,
	"./twitter-icon.webp": 730
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 303;